import { render, staticRenderFns } from "./filial.vue?vue&type=template&id=5158581c&"
import script from "./filial.vue?vue&type=script&lang=js&"
export * from "./filial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports